export enum CrudOperation {
    Create = 1,
    Read = 2,
    Update = 3,
    Delete = 4
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_entities/data/i-crud-operation.ts